import { LayoutComponent } from "@jelly/lesson";
import { linear as linear1, logarithmic as logarithmic1 } from "./harmonics-1";
import { linear as linear2, logarithmic as logarithmic2 } from "./harmonics-2";
import { linear as linear3, logarithmic as logarithmic3 } from "./harmonics-3";
import { linear as linear4, logarithmic as logarithmic4 } from "./harmonics-4";

const component: LayoutComponent = {
  variant: "layout",
  data: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        { type: "dropdown", items: [{ name: "Linear" }, { name: "Logarithmic" }], options: {} },
        {
          type: "dropdown",
          items: [{ name: "1 harmonic" }, { name: "2 harmonic" }, { name: "3 harmonic" }, { name: "4 harmonic" }],
          options: {},
        },
      ],
      extraContent: [[], []],
      components: [
        [linear1, linear2, linear3, linear4],
        [logarithmic1, logarithmic2, logarithmic3, logarithmic4],
      ],
    },
  },
};

export default component;
